import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import VerticalImageCard from './VerticalImageCard';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};


const dummyData = [
    {
      imageSrc: './foodImage.png',
      title: 'Food'
    },
    {
      imageSrc: 'https://media.istockphoto.com/id/183350112/photo/biohazard-bags.jpg?s=612x612&w=0&k=20&c=59Erlw3WJ0D95KHg09OgRWr7GFFuQ2Wida7503GrKDQ=',
      title: 'Biohazard'
    },
    {
      imageSrc: 'https://media.istockphoto.com/id/1172233289/photo/the-operation-of-automatic-plastic-bag-production-machine-with-lighting-effect.jpg?s=612x612&w=0&k=20&c=LM7URPeT0-RmHtpaUMHTt-xP4U0G5f7AiWinb4QwgWo=',
      title: 'Industrial'
    },
    {
      imageSrc: 'https://media.istockphoto.com/id/522793040/photo/drug-abuse.jpg?s=612x612&w=0&k=20&c=FEEFR0z_GNVfOo0um-T-JJPj9j0ayJINMQ_hbrWSU8E=',
      title: 'Pharmaceutical'
    },
    {
      imageSrc: 'https://media.istockphoto.com/id/1344240174/photo/brown-paper-bag-that-is-100-recyclable-and-reusable-on-a-counter.jpg?s=612x612&w=0&k=20&c=GFsK1KJsEhMLN_EryZxa0OtJ6-e5uodBRD2JtNkWqD4=',
      title: 'Retail'
    }
  ];
  

const Solutions = () => {
  return (
    <div
    id='solutions'
      className="relative bg-secondary py-12 bg-cover bg-center w-full"
      // style={{ backgroundImage: "url('https://media.istockphoto.com/id/865577704/photo/blue-abstract-glass-texture-background-or-pattern-creative-design-template.jpg?s=612x612&w=0&k=20&c=F-UBLPZt6XGB97fzjzITYxviW6yUZ_qQ5GmAt4xgBJ4=')" }}
    >
<div className="relative mb-10 z-10 text-center text-text-primary">
  <h3 className="text-text-primary text-lg font-semibold mb-2">Our Solutions</h3>
  <h2 className="text-3xl text-primary font-bold mt-2">A Perfect Match for All Industries</h2>
</div>


      <Carousel infinite autoPlay responsive={responsive} showDots={false}>
          {dummyData.map((sol) => <VerticalImageCard key={sol.title} imageSrc={sol.imageSrc} title={sol.title}/>)}
        </Carousel>

    </div>
  );
};

export default Solutions;
